import { isDesktop } from "./screenSize";
import { Video } from "./video";

export function enableSwatches() {
    if (isDesktop()) {
        $("body").on("mouseenter", ".swatch span", function () {
            if ($(this).is("[data-image]") && $(this).data("image").indexOf("no-image") == -1) {
                $(this)
                    .parents(".thumbnail")
                    .find(".product__imageContainer img:not(.secondary)")
                    .attr("src", $(this).data("image"));
                $(this)
                    .parents(".thumbnail")
                    .find(".product__imageContainer img:not(.secondary)")
                    .attr("srcset", $(this).data("image"));
            }
        });
    }
}

export function showVariantImage() {
    if (isDesktop()) {
        $("body").on("mouseenter", ".has-secondary-image-swap", function () {
            const $thumbnailImage = $(this).find(".product-image__wrapper img");
            const $thumbnailVideo = $(this).find(".product-image__wrapper .video-on-hover");
            if ($thumbnailImage) {
                $thumbnailImage.toggleClass("swap--visible");
            }
            if ($thumbnailVideo) {
                $thumbnailVideo.toggleClass("swap--visible");
                Video.enableVideoOnHover($(this));
            }
        });
        $("body").on("mouseleave", ".has-secondary-image-swap", function () {
            const $thumbnailImage = $(this).find(".product-image__wrapper img");
            const $thumbnailVideo = $(this).find(".product-image__wrapper .video-on-hover");
            if ($thumbnailImage) {
                $thumbnailImage.toggleClass("swap--visible");
            }
            if ($thumbnailVideo) {
                $thumbnailVideo.toggleClass("swap--visible");
                Video.disableVideoOnHover($(this));
            }
        });
    }
}
